<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-04-11 09:43:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-09-08 14:34:52
-->
<template>
  <div
    v-if="getImages.length > 0"
    :class="{ 'c-p-tb-25 c-p-lr-30': isPadding }"
  >
    <van-swipe class="my-swipe" :autoplay="300000" :style="cusStyle">
      <van-swipe-item v-for="(v, index) in getImages" :key="index">
        <img :src="prefix ? v[prefix] : v" class="img" :mode="mode" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  name: "GSwiper",
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    isPadding: {
      type: Boolean,
      default: false,
    },
    cusStyle: {
      type: Object,
      default: () => {},
    },
    prefix: {
      type: String,
    },
    mode: {
      type: String,
      default: "top",
    },
  },
  watch: {
    images(val) {
      this.getImages = val;
    },
  },
  data() {
    return {
      getImages: [
        "https://img01.yzcdn.cn/vant/apple-1.jpg",
        "https://img01.yzcdn.cn/vant/apple-2.jpg",
      ],
    };
  },
  created() {
    this.getImages = this.images || [];
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.my-swipe {
  height: 360px !important;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  /* background-color: #39a9ed; */
}
.img {
  width: 100%;
  height: 100% !important;
  border-radius: 12px;
}
</style>
